/** @format */

import React from "react";

//header
import Header from "../../components/partials/dashboard/HeaderStyle/user-header";

//sidebar
import RightSidebar from "../../components/partials/dashboard/SidebarStyle/rightsidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";

//settingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hook";
import * as RoleSelector from "src/store/role/selector";

const UserLayout = () => {
  const role = useAppSelector(RoleSelector.selectUserRole);

  if (role != "user") {
    return <Navigate replace to={"/errors/error404"} />;
  }
  return (
    <>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="position-relative">
          <Header />
          {/* <Views /> */}
          <Outlet />
        </div>
      </div>
      <RightSidebar />
      <Footer />
      <SettingOffCanvas />
    </>
  );
};

export default UserLayout;
